import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'singleDropdownSelectPipe'
})
export class SingleDropdownSelectPipe implements PipeTransform {

  transform(value: any): any {
    let substring = "(Modified)";
    let word = value;
    if (word.length <= 30) {
      return word;
    } else {
      if (word.indexOf(substring) !== -1) {
        return word.substr(0, 27) + '... ' + substring;
      } else {
        return word.substr(0, 30) + '...';
      }
    }
  }

}
